import * as React from 'react';
import showdown from 'showdown';
import DOMPurify from 'dompurify';

const markdownConverter = new showdown.Converter({moreStyling: true});

export default function Markdown({content}) {
  if (!content) return null;

  const html = DOMPurify.sanitize(markdownConverter.makeHtml(content));

  return (
    <div
      className='accordion-item__body accordion-item__body--md'
      dangerouslySetInnerHTML={{__html: html}}
    />
  );
}
